import React, { ComponentProps } from "react";
import { Modal } from "react-bootstrap";

import { UPLOADED_IMAGE_URL } from "../lib/globals";
import { IImage } from "../types/shared";

const ImageModal = (
    props: IImage & ComponentProps<typeof Modal>,
): React.ReactElement => {
    return (
        <Modal
            {...props}
            size="lg"
            centered
            className="imageModal"
            data-testid="imageModal"
        >
            <Modal.Body>
                <img
                    src={`${UPLOADED_IMAGE_URL}${props.image}`}
                    alt={props.alt}
                />
            </Modal.Body>
            <Modal.Footer>{props.alt}</Modal.Footer>
        </Modal>
    );
};

export default ImageModal;
